export enum LinkTarget {
  NEW_WINDOW = "_blank",
  SELF = "_self",
  PARENT = "_parent",
  TOP = "_top"
}

export enum IconPosition {
  START = "start",
  END = "end"
}
